import MyDemandContent from './MyDemandContent.jsx';
import MyDemandDetailContent from './MyDemandDetailContent';

export {MyDemandContent, MyDemandDetailContent};



// WEBPACK FOOTER //
// ./components/users/my-demand-content/index.js